import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_InitialAssessmentV2 = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_InitialAssessmentV2' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'><h3>Initial Assessment & Crisis Plan</h3></p>

                <p className='w-750'>
                    <span className='eleHeader'>Informant:</span>
                    <input type='checkbox' id='cbInformant_1' name='cbInformant_1' className='add-only' value='Informant_1' />
                    Individual Receiving Services
                    &nbsp;
                    <input type='checkbox' id='cbInformant_2' name='cbInformant_2' className='add-only' value='Informant_2' />
                    Other: Relationship to Individual

                    <input type='text' id='txtInformant_2' name='txtInformant_2' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does the person seeking services have an Outpatient Commitment Order?</span>
                    <input type='radio' id='rbOutpatientCommitmentOrder_Yes' name='rbOutpatientCommitmentOrder' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbOutpatientCommitmentOrder_No' name='rbOutpatientCommitmentOrder' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><b>GUARDIANSHIP INFORMATION</b></p>

                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Name of Guardian / Custodian:</span></td>
                        <td className='w-300'><span className='eleHeader'>Guardianship Documentation Verified:</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='text' id='txtGuardianName' name='txtGuardianName' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='radio' id='rbGuardianDocumentation_Yes' name='rbGuardianDocumentation' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbGuardianDocumentation_No' name='rbGuardianDocumentation' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Guardian / Custodian Address:</span></td>
                        <td className='w-300'><span className='eleHeader'>Guardian / Custodian Phone Number:</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='text' id='txtGuardianAddress' name='txtGuardianAddress' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txtGuardianPhone' name='txtGuardianPhone' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Is the family involved with the Department of Human Services?</span>
                    <input type='radio' id='rbDepartmentHumanServices_Yes' name='rbDepartmentHumanServices' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDepartmentHumanServices_No' name='rbDepartmentHumanServices' className='add-only' value='No' /> No

                </p>
                <p className='w-750'>
                    If yes, has a consent to release information been obtained? &nbsp;
                    <input type='radio' id='rbDepartmentHumanServicesIfYes_Yes' name='rbDepartmentHumanServicesIfYes' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDepartmentHumanServicesIfYes_No' name='rbDepartmentHumanServicesIfYes' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    If yes, please explain and indicate the name of the assigned case worker.
                    <textarea id='txtDepartmentHumanServicesExplain' name='txtDepartmentHumanServicesExplain' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>CONFIDENTIALITY</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Were the limits of confidentiality reviewed with Individual and/or Guardian?</span>
                    <input type='radio' id='rbConfidentialityReviewed_Yes' name='rbConfidentialityReviewed' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbConfidentialityReviewed_No' name='rbConfidentialityReviewed' className='add-only' value='No' /> No <br />
                    If NO, please explain.
                    <textarea id='txtConfidentialityReviewedExplain' name='txtConfidentialityReviewedExplain' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>DESCRIPTION OF NEED</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>What is your reason for seeking services today? What specific needs do you currently have?</span>
                    <span className='small'>(Include a description/perception of difficulties according to the individual seeking services and any applicable family
                        members/ legal guardian.)
                    </span>
                    <textarea id='txtReasonForSeekingServices' name='txtReasonForSeekingServices' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is the reason for seeking services today related to substance use?</span>
                    <input type='radio' id='rbReasonForSeekingServicesRelatedSubstanceUse_Yes' name='rbReasonForSeekingServicesRelatedSubstanceUse' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbReasonForSeekingServicesRelatedSubstanceUse_No' name='rbReasonForSeekingServicesRelatedSubstanceUse' className='add-only' value='No' /> No <br />
                    If yes, the substance use specific assessment must also be completed.
                    <textarea id='txtReasonForSeekingServicesRelatedSubstanceUseIfYes' name='txtReasonForSeekingServicesRelatedSubstanceUseIfYes' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What previous coping skills have been helpful in the past?</span>
                    <textarea id='txtCopingSkills' name='txtCopingSkills' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Thoughts of Suicide:</span>
                    <input type='radio' id='rbThoughtsSuicide_Yes' name='rbThoughtsSuicide' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbThoughtsSuicide_No' name='rbThoughtsSuicide' className='add-only' value='No' /> No  (If yes, explain)
                    <textarea id='txtThoughtsSuicide' name='txtThoughtsSuicide' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Attempts of Suicide:</span>
                    <input type='radio' id='rbAttemptsSuicide_Yes' name='rbAttemptsSuicide' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAttemptsSuicide_No' name='rbAttemptsSuicide' className='add-only' value='No' /> No  (If yes, explain)
                    <textarea id='txtAttemptsSuicide' name='txtAttemptsSuicide' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Thoughts of Homicide:</span>
                    <span className='small'>(Indicate the need for 'duty to warn')</span>
                    <input type='radio' id='rbThoughtsHomicide_Yes' name='rbThoughtsHomicide' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbThoughtsHomicide_No' name='rbThoughtsHomicide' className='add-only' value='No' /> No (If yes, explain)
                    <textarea id='txtThoughtsHomicide' name='txtThoughtsHomicide' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>cts of Self-Harm:</span>
                    <input type='radio' id='rbSelfHarm_Yes' name='rbSelfHarm' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSelfHarm_No' name='rbSelfHarm' className='add-only' value='No' /> No (If yes, explain)
                    <textarea id='txtSelfHarm' name='txtSelfHarm' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>SOCIAL / CULTURAL</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Identification of Support Systems:</span>
                    <span className='small'>(Address family relationships, interpersonal relationships, and community support systems)</span>
                    <textarea id='txtIdentificationSupportSystems' name='txtIdentificationSupportSystems' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Meaningful Activities, Cultural / Ethnic I Spiritual interests, Supports:</span>
                    <span className='small'>(Address hobbies, leisure activities, etc.)</span>
                    <textarea id='txtMeaningfulActivities' name='txtMeaningfulActivities' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>Living Situation</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>What is your current living arrangement (strengths and concerns)? Who lives with you? What are your views
                        on your current arrangement?
                    </span>
                    <textarea id='txtCurrentLivingArrangement' name='txtCurrentLivingArrangement' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Needs Related to Living Situation </span>
                    <span className='small'>(money management, benefits, living arrangements, clothing, personal care, child care, rent, other)</span>
                    <textarea id='txtNeedsRelatedLivingSituation' name='txtNeedsRelatedLivingSituation' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>Developmental History (Complete only for Children & Youth up to age 21 and everyone with ID/DD)</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>During pregnancy, did mother use alcohol or other drugs?</span>
                    <textarea id='txtDevelopmentalHistory_1' name='txtDevelopmentalHistory_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any problems with the pregnancy or birth:</span>
                    <textarea id='txtDevelopmentalHistory_2' name='txtDevelopmentalHistory_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Were there any developmental issues?</span>
                    <input type='radio' id='rbDevelopmentalHistory_3Yes' name='rbDevelopmentalHistory_3' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDevelopmentalHistory_3No' name='rbDevelopmentalHistory_3' className='add-only' value='No' /> No (If yes, explain)
                    <textarea id='txtDevelopmentalHistory_3' name='txtDevelopmentalHistory_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any childhood accidents or injuries:</span>
                    <textarea id='txtDevelopmentalHistory_4' name='txtDevelopmentalHistory_4' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>Education (Children & Youth up to age 21)</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Name of school:</span>
                    <input type='text' id='txtNameSchool' name='txtNameSchool' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does child/youth receive Special Education Services?</span>
                    <input type='radio' id='rbSpecialEducationServices_Yes' name='rbSpecialEducationServices' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSpecialEducationServices_No' name='rbSpecialEducationServices' className='add-only' value='No' /> No <br />
                    <span className='small'>(If yes, complete release of information to obtain a copy of the current Individualized Education Plan (IEP))</span>
                </p>

                <p className='w-750'><b>Additional Information (Children & Youth up to age 21)</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Educational Issues/ Needs</span>
                    <span className='small'>( grades, attendance,suspensions,expulsions)</span>
                    <textarea id='txtEducationalIssues' name='txtEducationalIssues' className='add-only'></textarea>

                </p>
                <p className='w-750'><b>Employment (adults only)</b></p>
                <p className='w-750'>

                    <span className='eleHeader'>Are you employed?</span>
                    <input type='radio' id='rbEmployed_Yes' name='rbEmployed' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbEmployed_No' name='rbEmployed' className='add-only' value='No' /> No


                </p>
                <p className='w-750'>
                    If no, do you want to be employed? &nbsp;
                    <input type='radio' id='rbWantEmployed_Yes' name='rbWantEmployed' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbWantEmployed_No' name='rbWantEmployed' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>

                    <span className='eleHeader'>Employment Barriers/ Related Needs?</span>
                    <textarea id='txtEmploymentBarriers' name='txtEmploymentBarriers' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>Current Legal Status</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Has the individual been involved with the legal system within the past twelve months?</span>
                    <input type='radio' id='rbLegalSystem_Yes' name='rbLegalSystem' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLegalSystem_No' name='rbLegalSystem' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Arrests:</span>
                    <input type='radio' id='rbArrests_Yes' name='rbArrests' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbArrests_No' name='rbArrests' className='add-only' value='No' /> No <br />
                    If yes, indicate type and number of arrest(s):
                    <input type='text' id='txtTypeAndNumberOfArrest' name='txtTypeAndNumberOfArrest' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Number of arrests in the past 30 days:</span>
                    <input type='text' id='txtNumberArrests' name='txtNumberArrests' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Pending Charges:</span>
                    <input type='radio' id='rbPendingCharges_Yes' name='rbPendingCharges' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPendingCharges_No' name='rbPendingCharges' className='add-only' value='No' /> No <br />
                    If yes, indicate type and number of pending charges:
                    <input type='text' id='txtTypeAndNumberOfPendingChanrges' name='txtTypeAndNumberOfPendingChanrges' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is this person currently on parole and/or probation?</span>
                    <input type='radio' id='rbParole_Yes' name='rbParole' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbParole_No' name='rbParole' className='add-only' value='No' /> No If applicable, indicate to whom reports should be submitted:
                    <input type='text' id='txtWhomReportsShouldSubmitted' name='txtWhomReportsShouldSubmitted' className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Use Related Legal Issues:</span>
                    <textarea id='txtSubstanceUseRelatedLegalIssues' name='txtSubstanceUseRelatedLegalIssues' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>Medical History</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Appetite Issues:</span>
                    <textarea id='txtAppetite' name='txtAppetite' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Sleep Issues:</span>
                    <textarea id='txtSleep' name='txtSleep' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Current or Chronic Diseases</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentChronicDiseases_1' name='cbCurrentChronicDiseases_1' className='add-only' value='CurrentChronicDiseases_1' />
                            high blood pressure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentChronicDiseases_2' name='cbCurrentChronicDiseases_2' className='add-only' value='CurrentChronicDiseases_2' />
                            diabetes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCurrentChronicDiseases_3' name='cbCurrentChronicDiseases_3' className='add-only' value='CurrentChronicDiseases_3' />
                            thyroid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCurrentChronicDiseases_4' name='cbCurrentChronicDiseases_4' className='add-only' value='CurrentChronicDiseases_4' /> Other: &nbsp;
                            <input type='text' id='txtCurrentChronicDiseases_4' name='txtCurrentChronicDiseases_4' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Family History:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyHistory_1' name='cbFamilyHistory_1' className='add-only' value='FamilyHistory_1' />
                            high blood pressure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyHistory_2' name='cbFamilyHistory_2' className='add-only' value='FamilyHistory_2' />
                            diabetes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyHistory_3' name='cbFamilyHistory_3' className='add-only' value='FamilyHistory_3' />
                            thyroid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamilyHistory_4' name='cbFamilyHistory_4' className='add-only' value='FamilyHistory_4' /> Other: &nbsp;
                            <input type='text' id='txtFamilyHistory_4' name='txtFamilyHistory_4' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Medical History or Health and Safety Issues:</span>
                    <textarea id='txtAdditionalMedicalHistory' name='txtAdditionalMedicalHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Health-Related Needs:</span>
                    <textarea id='txtHealthRelatedNeeds' name='txtHealthRelatedNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>INDIVIDUAL MENTAL HEALTH HISTORY</b></p>
                <p className='w-750'><b>Previous Assessment History</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Have psychological, educational or functional assessments been completed in the last twelve months?</span>
                    <input type='radio' id='rbPsychologicalEducationalFunctional_Yes' name='rbPsychologicalEducationalFunctional' className='add-only' value='Yes' /> Yes (If yes, complete release of information to obtain a copy of the applicable assessment.) &nbsp;
                    <input type='radio' id='rbPsychologicalEducationalFunctional_No' name='rbPsychologicalEducationalFunctional' className='add-only' value='No' /> No If yes, indicate type of assessment


                    <textarea id='txtPsychologicalEducationalFunctionalIfYes' name='txtPsychologicalEducationalFunctionalIfYes' className='add-only'></textarea>

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Previous or Current Diagnoses:</span>
                    <textarea id='txtPreviousCurrentDiagnoses' name='txtPreviousCurrentDiagnoses' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Mental Health Needs:</span>
                    <textarea id='txtMentalHealthNeeds' name='txtMentalHealthNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Family History of Psychiatric or Substance Use Disorder(s)</span>
                    <input type='radio' id='rbFamilyHistoryPsychiatric_Yes' name='rbFamilyHistoryPsychiatric' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFamilyHistoryPsychiatric_No' name='rbFamilyHistoryPsychiatric' className='add-only' value='No' /> No

                    If yes, please describe.
                    <textarea id='txtFamilyHistoryPsychiatric' name='txtFamilyHistoryPsychiatric' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>Outpatient Behavioral Health Agency</b></p>
                <p className='w-750'>
                    <input type='checkbox' id='cbOutpatientBehavioralHealthAgencyNoneReported' name='cbOutpatientBehavioralHealthAgencyNoneReported' className='add-only' value='NoneReported' /> None Reported
                </p>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Treatment Agency</span></td>
                        <td className='w-200'><span className='eleHeader'>Services Received </span></td>
                        <td className='w-150'><span className='eleHeader'>Dates of Service</span></td>
                        <td className='w-200'><span className='eleHeader'>Has Consent to Release Information Been Requested?</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtTreatmentAgency_1' name='txtTreatmentAgency_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtServicesReceived_1' name='txtServicesReceived_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesService_1' name='txtDatesService_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbConsentInformationRequestedYes_1' name='rbConsentInformationRequested_1' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbConsentInformationRequestedNo_1' name='rbConsentInformationRequested_1' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtTreatmentAgency_2' name='txtTreatmentAgency_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtServicesReceived_2' name='txtServicesReceived_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesService_2' name='txtDatesService_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbConsentInformationRequestedYes_2' name='rbConsentInformationRequested_2' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbConsentInformationRequestedNo_2' name='rbConsentInformationRequested_2' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtTreatmentAgency_3' name='txtTreatmentAgency_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtServicesReceived_3' name='txtServicesReceived_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesService_3' name='txtDatesService_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbConsentInformationRequestedYes_3' name='rbConsentInformationRequested_3' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbConsentInformationRequestedNo_3' name='rbConsentInformationRequested_3' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtTreatmentAgency_4' name='txtTreatmentAgency_4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtServicesReceived_4' name='txtServicesReceived_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesService_4' name='txtDatesService_4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbConsentInformationRequestedYes_4' name='rbConsentInformationRequested_4' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbConsentInformationRequestedNo_4' name='rbConsentInformationRequested_4' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'><b>Psychiatric Hospitalizations / Residential Treatment</b></p>
                <p className='w-750'>
                    <input type='checkbox' id='cbPsychiatricHospitalizationsResidentialTreatmentNoneReported' name='cbPsychiatricHospitalizationsResidentialTreatmentNoneReported' className='add-only' value='NoneReported' /> None Reported
                </p>
                <table>
                    <tr>
                        <td className='w-200'><span className='eleHeader'>Treatments</span></td>
                        <td className='w-200'><span className='eleHeader'>Reason (suicidal, depressed, etc.)</span></td>
                        <td className='w-150'><span className='eleHeader'>Dates of Service</span></td>
                        <td className='w-200'><span className='eleHeader'>Has Consent to Release Information Been Requested?</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtTreatments_1' name='txtTreatments_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_1' name='txtReason_1' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesService_5' name='txtDatesService_5' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbConsentInformationRequestedYes_5' name='rbConsentInformationRequested_5' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbConsentInformationRequestedNo_5' name='rbConsentInformationRequested_5' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtTreatments_2' name='txtTreatments_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_2' name='txtReason_2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesService_6' name='txtDatesService_6' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbConsentInformationRequestedYes_6' name='rbConsentInformationRequested_6' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbConsentInformationRequestedNo_6' name='rbConsentInformationRequested_6' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtTreatments_3' name='txtTreatments_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_3' name='txtReason_3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesService_7' name='txtDatesService_7' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbConsentInformationRequestedYes_7' name='rbConsentInformationRequested_7' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbConsentInformationRequestedNo_7' name='rbConsentInformationRequested_7' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtTreatments_4' name='txtTreatments_4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_4' name='txtReason_4' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDatesService_8' name='txtDatesService_8' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbConsentInformationRequestedYes_8' name='rbConsentInformationRequested_8' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbConsentInformationRequestedNo_8' name='rbConsentInformationRequested_8' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'><b>Initial Observations</b></p>

                <p className='w-750'><b>General Observations</b></p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Appearance:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='Appearance_1' />
                            Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Appearance_2' />
                            Disheveled
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='Appearance_3' />
                            Unclean
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAppearance_4' name='cbAppearance_4' className='add-only' value='Appearance_4' /> Other: &nbsp;
                            <input type='text' id='txtAppearance_4' name='txtAppearance_4' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Speech:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Speech_1' />
                            Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Speech_2' />
                            Slow
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Speech_3' />
                            Mechanical
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Speech_4' />
                            Rapid
                        </td>
                        </tr>
                        <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Speech_5' /> Other: &nbsp;
                            <input type='text' id='txtSpeech_5' name='txtSpeech_5' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Affect:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Affect_1' />
                            Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Affect_2' />
                            Flat
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Affect_3' />
                            Labile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Affect_4' /> Other: &nbsp;
                            <input type='text' id='txtAffect_4' name='txtAffect_4' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Delusions:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDelusions_1' name='cbDelusions_1' className='add-only' value='Delusions_1' />
                            N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDelusions_2' name='cbDelusions_2' className='add-only' value='Delusions_2' /> Description: &nbsp;
                            <input type='text' id='txtDelusions_2' name='txtDelusions_2' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Hallucinations:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHallucinations_1' name='cbHallucinations_1' className='add-only' value='Hallucinations_1' />
                            N/A
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHallucinations_2' name='cbHallucinations_2' className='add-only' value='Hallucinations_2' /> Description: &nbsp;
                            <input type='text' id='txtHallucinations_2' name='txtHallucinations_2' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Mood:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='Mood_1' />
                            Appropriate
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Mood_2' />
                            Manic
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_3' name='cbMood_3' className='add-only' value='Mood_3' />
                            Depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Mood_4' />
                            Labile
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Mood_5' />
                            Irritable
                        </td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Mood_6' /> Other: &nbsp;
                            <input type='text' id='txtMood_6' name='txtMood_6' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Orientation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1' name='cbOrientation_1' className='add-only' value='Orientation_1' />
                            Person
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_2' name='cbOrientation_2' className='add-only' value='Orientation_2' />
                            Place
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_3' name='cbOrientation_3' className='add-only' value='Orientation_3' />
                            Time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_4' name='cbOrientation_4' className='add-only' value='Orientation_4' />
                            Situation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOrientation_5' name='cbOrientation_5' className='add-only' value='Orientation_5' /> Other: &nbsp;
                            <input type='text' id='txtOrientation_5' name='txtOrientation_5' className='add-only w-350 custom-add-only' />

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Indication Of Functional Limitation(s):
                        (Check Major Life Areas Affected)
                    </b>
                </p>
                <p className='w-750'>

                    <span className='eleHeader'>Basic living skills </span>
                    <span className='small'>(eating, bathing, dressing, etc.)</span>
                    <textarea id='txtBasicLivingSkills' name='txtBasicLivingSkills' className='add-only'></textarea>
                </p>
                <p className='w-750'>

                    <span className='eleHeader'>Instrumental living skills</span>
                    <span className='small'>(maintain a household, managing money, getting around the community,
                        taking prescribed medications, etc.)
                    </span>
                    <textarea id='txtInstrumentalLivingSkills' name='txtInstrumentalLivingSkills' className='add-only'></textarea>
                </p>
                <p className='w-750'>

                    <span className='eleHeader'>Social functioning </span>
                    <span className='small'>(ability to function within the family, vocational or educational function, other social
                        contexts, etc.)
                    </span>
                    <textarea id='txtSocialFunctioning' name='txtSocialFunctioning' className='add-only'></textarea>
                </p>
                <p className='w-750'><b>SUMMARY / RECOMMENDATIONS</b></p>
                <p className='w-750'>
                    <span className='eleHeader'>Health:</span>
                    <textarea id='txtHealth' name='txtHealth' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Home:</span>
                    <textarea id='txtHome' name='txtHome' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Community:</span>
                    <textarea id='txtCommunity' name='txtCommunity' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Purpose:</span>
                    <textarea id='txtPurpose' name='txtPurpose' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Other:</span>
                    <textarea id='txtOther' name='txtOther' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>INITIAL DIAGNOSTIC IMPRESSION</b>
                </p>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Codes:</span></td>
                        <td className='w-600'><span className='eleHeader'>Description:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCodes_1' name='txtCodes_1' className='add-only' />
                        </td>
                        <td className='w-600'>
                            <input type='text' id='txtDescription_1' name='txtDescription_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCodes_2' name='txtCodes_2' className='add-only' />
                        </td>
                        <td className='w-600'>
                            <input type='text' id='txtDescription_2' name='txtDescription_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCodes_3' name='txtCodes_3' className='add-only' />
                        </td>
                        <td className='w-600'>
                            <input type='text' id='txtDescription_3' name='txtDescription_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCodes_4' name='txtCodes_4' className='add-only' />
                        </td>
                        <td className='w-600'>
                            <input type='text' id='txtDescription_4' name='txtDescription_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCodes_5' name='txtCodes_5' className='add-only' />
                        </td>
                        <td className='w-600'>
                            <input type='text' id='txtDescription_5' name='txtDescription_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCodes_6' name='txtCodes_6' className='add-only' />
                        </td>
                        <td className='w-600'>
                            <input type='text' id='txtDescription_6' name='txtDescription_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtCodes_7' name='txtCodes_7' className='add-only' />
                        </td>
                        <td className='w-600'>
                            <input type='text' id='txtDescription_7' name='txtDescription_7' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>SIGNATURES / CREDENTIALS</b></p>

                <table>
                    <tr>
                        <td className='signature w-480'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-480'>Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                    <tr>
                        <td className='signature w-480'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-480'>Signature:</td>
                        <td className='small w-250'>Date:</td>
                    </tr>
                </table>

            </div >
        </form >
    )
}
